import { css } from 'styled-components';

export const DisplayBlockOnPrint = css`
	@media print {
		display: block;
	}
`;

export const DisplayBlockOnPrintOnly = css`
	display: none;

	@media print {
		display: block;
	}
`;

export const DisplayNoneOnPrint = css`
	@media print {
		display: none;
	}
`;
